import _ from 'underscore';
import PropTypes from 'prop-types';
import React from 'react';

import CustomSelect from 'components/filters/CustomSelect';

import styles from './styles.module.scss';

export const sortOptions = [
	{
		title: 'Самые популярные',
		name: '-views'
	},
	{
		title: 'Менее популярные',
		name: 'views'
	},
	{
		title: 'Свежие публикации',
		name: '-publishDate'
	},
	{
		title: 'Давние публикации',
		name: 'publishDate'
	}
];

const SortFilters = ({
	currentSort,
	onFilterChange,
	options = sortOptions
}) => {
	const currentSortTitle =
		_(sortOptions).findWhere({ name: currentSort })?.title || '';

	return (
		<CustomSelect
			options={options}
			selectedValue={currentSort}
			name="sort"
			onChange={onFilterChange}
			resetOption={null}
			ariaLabelButton={`Сортировка. ${currentSortTitle}`}
			titleClassName={styles.SortFiltersTitle}
		/>
	);
};

SortFilters.propTypes = {
	currentSort: PropTypes.string.isRequired,
	onFilterChange: PropTypes.func.isRequired,
	options: PropTypes.array
};

export default SortFilters;
